import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Home from './pages/Home';
import Admisiones from './pages/Admisiones';
import Contacto from './pages/Contacto';
import AcercaDe from './pages/AcercaDe';
import Ubicacion from './pages/Ubicacion';
import Voluntariado from './pages/Voluntariado';

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admisiones" element={<Admisiones />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/acerca-de" element={<AcercaDe />} />
          <Route path="/ubicacion" element={<Ubicacion />} />
          <Route path="/voluntariado" element={<Voluntariado />} />
        </Routes>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
